window.shouldRedirectToCartPage = () => window.themeCartSettings?.addBehavior === 'page';

function refreshCartJS() {
  if (document.body?.classList?.contains('template--landing-without-header')) {
    window.location.assign(window.routes?.cart_url || '/cart');
    return;
  }
  const cartSlide = document.querySelector('cart-slide');
  if (cartSlide) {
    if (cartSlide.refreshCart) cartSlide.refreshCart();
    if (!window.shouldRedirectToCartPage() && cartSlide.toggleCart && !cartSlide.classList.contains('active')) {
      cartSlide.toggleCart();
    }
  }
}

function customMiniCartRelatedProductAddToCart(id, quantity, openCart) {
  // Validate variant ID
  if (!id || id === '' || id === 'undefined' || id === 'null') {
    console.error('Invalid variant ID:', id);
    alert('Please select a product variant');
    return;
  }

  // Validate quantity
  if (!quantity || 1 > quantity || isNaN(quantity)) {
    console.error('Invalid quantity:', quantity);
    alert('Please enter a valid quantity');
    return;
  }

  const formData = {
    'items': [{
      'id': String(id), // Ensure ID is a string
      'quantity': parseInt(quantity, 10)
    }]
  };

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
        return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
        });
    }
    return response.json();
  })
  .then(response => {
    if (window.shouldRedirectToCartPage()) {
      window.location.href = window.routes?.cart_url || '/cart';
      return;
    }
    refreshCartJS();
    if (openCart) {
       const cartSlide = document.querySelector('cart-slide');
       if (cartSlide && !cartSlide.classList.contains('active') && cartSlide.toggleCart) {
           cartSlide.toggleCart();
       }
    }
  })
  .catch(function(error) {
    console.error('Add to cart error:', error);
    alert(error.message || error);
  });
}

function ajaxCartCall() {
    refreshCartJS();
}

function miniCartRefresh(openCart) {
    refreshCartJS();
}
